// * =============================== [ GENERAL ]
export const GENERIC_SWIPER = {
    PAGE_SLIDE_MAX_COUNT: 25,
    HOVER_EXPAND_TRANSITION_MS: 300, // Da tenere in sincornizzazione con il duration-XXX del mouseover delle slide portrait quando fanno la transizione
    SLIDE: {
        LANDSCAPE: {
            MOUSEOVER: { FIT_SLIDE_INTO_VIEW_SPACING: 30 },
            OFFSET_AFTER_SLIDES: 50,
        },
        PORTRAIT: {
            MOUSEOVER: { FIT_SLIDE_INTO_VIEW_SPACING: 50 },
            OFFSET_AFTER_SLIDES: 450,
        },
    },
};
// * =============================== [ NAVBAR ]
export const NAVBAR = {
    HEIGHT: { MOBILE: "h-14", DESKTOP: "h-16" },
};
// * =============================== [ HOMEPAGE ]
export const HOMEPAGE = {
    CACHE_TIMEOUT: 1, // 1ms // ! DA RIMETTERE staleTime GIUSTO
    SECTIONS_TO_LOAD_COUNT: 3,
    SECTIONS_LOAD_SCROLL_TRESHOLD: 85,
    HERO_SECTION_AUTOPLAY_DELAY: 5000,
};
// * =============================== [ WATCH VIDEO ]
export const WATCH_VIDEO = {
    CACHE_TIMEOUT: 1, // 1ms // ! DA RIMETTERE staleTime GIUSTO
};
// * =============================== [ WATCH REEL ]
export const WATCH_REEL = {
    CACHE_TIMEOUT: 1, // 1ms // ! DA RIMETTERE staleTime GIUSTO
};
